import { render } from "./SimakadHome.vue?vue&type=template&id=2e46b300"
import script from "./SimakadHome.vue?vue&type=script&lang=js"
export * from "./SimakadHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__